import { useContext } from 'react'
import { FeatureFlagsContext } from './FeatureFlagsContext'

export const useFeatureFlag: (flag: string) => boolean = (flag) => {
    const featureFlags = useContext(FeatureFlagsContext)
    return typeof featureFlags?.[flag] === 'boolean'
        ? featureFlags[flag]
        : false
}
